import styled from "styled-components";
import { ImageList, ImageListItem, Skeleton, Stack } from "@mui/material";
import { WarehousesGallery } from "../../../../../services/warehouses/get-all/types";
import { ActionBar } from "../action-bar";
import { theme } from "../../../../../helpers/theme";

interface ImageGalleryProps {
  imagesList: WarehousesGallery[];
  magazyn_id: string;
  isGalleryLoading: boolean;
  setImagesList: (imagesList: WarehousesGallery[]) => void;
  setIsGalleryLoading:(isGalleryLoading: boolean) => void;
}

export const ImageGallery = ({
  imagesList,
  magazyn_id,
  isGalleryLoading,
  setImagesList,
  setIsGalleryLoading,

}: ImageGalleryProps) => {
  if (isGalleryLoading) {
    return (
      <Stack>
        <Skeleton variant="rounded" width={800} height={560} />
      </Stack>
    );
  }

  return imagesList.length > 0 ? (
    <ImageList
      sx={{
        width: "90%",
        height: "80%",
        margin: "auto auto",
      }}
      //variant="masonry"
      cols={imagesList.length>2?3:(imagesList.length===2?2:1)}
      gap={8}
    >
      {imagesList.map((item) => (
        <ImageListItem key={item.id_zdjecie} sx={{}}>
          <img
            src={`${item.url}?w=248&fit=crop&auto=format`}
            srcSet={`${item.url}?w=248&fit=crop&auto=format&dpr=2 2x`}
            alt={"warehouse img"}
            loading="lazy"
            style={{
              borderTopLeftRadius: "8px",
              WebkitBorderTopRightRadius: "8px",
            //   width:"100px",
            //   height:"100px",
            //   backgroundSize: "cover",
            }}
          />
          {/* <ImageListItemBar
              title={item.title}
              subtitle={<span>by: {item.author}</span>}
              position="below"
            /> */}

          <ActionBar
            MagazynId={magazyn_id}
            zdjecie_id={item.id_zdjecie}
            url={item.url}
            setImagesList={setImagesList}
            setIsGalleryLoading={setIsGalleryLoading}
          />
        </ImageListItem>
      ))}
    </ImageList>
  ) : (
    <EmptyGallery>Galeria zdjęć jest pusta</EmptyGallery>
  );
};

const EmptyGallery=styled.div`
margin:90px auto;
font-weight: 500;
font-size: 16px;
line-height: 24px;
font-family: Inter Regular;
backbround-color:${theme.colors.gray01_secondaryText}

`
